export const OTP_INLINE = {
  VERIFY_PHONE_AUTH_DESCRIPTION:
    'Ten en cuenta que el número de teléfono que ingreses será utilizado como método de autenticación para acceder a tu cuenta.',
} as const;

export const RECAPTCHA_V2_REQUIRED_MESSAGE =
  'Completa la verificación reCAPTCHA para recibir tu código';

export const RECAPTCHA_V2_ABANDONED_MESSAGE =
  'No se completó la verificación reCAPTCHA. Vuelve a intentarlo';
